import { useState, useEffect, useCallback } from "react";
import { Api } from "../../../../api";
import { useCacheContext, CacheKeys } from "../../../Cache";

export const useEnvironmentsListItem = (
  internalUrl: string,
  prodUrl: string
) => {
  const [intenalVersion, setUatVersion] = useState("-");
  const [prodVersion, setProdVersion] = useState("-");
  const { saveToCache, getFromCache } = useCacheContext();

  const getVersion = useCallback(
    async (url: string) => {
      const cacheKey = `${CacheKeys.environmentVersion} ${url}`;
      const cacheData = getFromCache(cacheKey);

      if (cacheData) {
        return cacheData;
      }

      const environmentData = await Api.getEnvVersion(url);

      saveToCache(cacheKey, environmentData.data?.version);

      return environmentData.data?.version;
    },
    [saveToCache, getFromCache]
  );

  const getUatVersion = useCallback(async () => {
    if (internalUrl) {
      const uatVersion = await getVersion(internalUrl);

      setUatVersion(uatVersion);
    }
  }, [getVersion, internalUrl]);

  const getProdVersion = useCallback(async () => {
    if (prodUrl) {
      const prodVersion = await getVersion(prodUrl);

      setProdVersion(prodVersion);
    }
  }, [getVersion, prodUrl]);

  useEffect(() => {
    getUatVersion();
    getProdVersion();
  }, [getProdVersion, getUatVersion]);

  return {
    intenalVersion,
    prodVersion,
  } as const;
};
